/* istanbul ignore file */
// TODO: Create test file

/* eslint-disable import/prefer-default-export */
export const FETCH = 'fetch';
export const TOGGLE = 'toggle';
